class Referrer {
	constructor(referrer, destUrl) {
		// Базовая часть URL
		this.baseUrl = '//counter.yadro.ru/hit;mk?r';

		// Кодируем источник (referrer)
		this.encodedReferrer = escape(referrer);

		// Проверяем, определены ли характеристики экрана
		this.screenInfo = typeof screen == 'undefined' ? '' : ';s' + screen.width + '*' + screen.height + '*' + (screen.colorDepth ? screen.colorDepth : screen.pixelDepth);

		// Кодируем целевой URL
		this.encodedDestUrl = escape(destUrl);

		// Кодируем заголовок документа и обрезаем до 80 символов
		this.encodedTitle = escape(document.title.substring(0, 80));

		// Добавляем случайное число для предотвращения кэширования
		this.randomNumber = Math.random();

		// Собираем все части вместе для формирования итогового URL
		this.finalUrl = this.baseUrl + this.encodedReferrer + this.screenInfo + ';u' + this.encodedDestUrl + ';h' + this.encodedTitle + ';' + this.randomNumber;
	}

	setCounter() {
		try {
			new Image().src = this.finalUrl;
		} catch (exeption) {
			console.error(`LiveInternet Exeption: ${exeption}`);
		}
	}
}

export default Referrer;
